import React from "react";
import { Tag } from "antd";

const RequirementTag = ({ requirement }) => {
  const tagProps = {
    skill: { color: "orange" },
    quest: { color: "volcano" },
    slayer_reward: { color: "gold" },
  };

  const { color } = tagProps[requirement.type];
  const content =
    requirement.type === "skill"
      ? `${requirement.name}: ${requirement.level}`
      : `${requirement.name}`;

  return <Tag color={color}>{content}</Tag>;
};

export default RequirementTag;
